
var __extends = this.__extends || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    __.prototype = b.prototype;
    d.prototype = new __();
};
define('backend/XmlHttpRequest',["require", "exports", '../core/file_system', '../generic/file_index', '../core/buffer', '../core/api_error', '../core/file_flag', '../generic/preload_file', '../core/browserfs', '../generic/xhr'], function(require, exports, file_system, file_index, buffer, api_error, file_flag, preload_file, browserfs, xhr) {
    var Buffer = buffer.Buffer;
    var ApiError = api_error.ApiError;
    var ErrorCode = api_error.ErrorCode;
    var FileFlag = file_flag.FileFlag;
    var ActionType = file_flag.ActionType;

    var XmlHttpRequest = (function (_super) {
        __extends(XmlHttpRequest, _super);
        function XmlHttpRequest(listing_url, prefix_url) {
            _super.call(this);
            if (listing_url == null) {
                listing_url = 'index.json';
            }
            this.prefix_url = prefix_url != null ? prefix_url : '';
            var listing = this._requestFileSync(listing_url, 'json');
            if (listing == null) {
                throw new Error("Unable to find listing at URL: " + listing_url);
            }
            this._index = file_index.FileIndex.from_listing(listing);
        }
        XmlHttpRequest.prototype.empty = function () {
            this._index.fileIterator(function (file) {
                file.file_data = null;
            });
        };

        XmlHttpRequest.prototype._requestFileSizeAsync = function (path, cb) {
            xhr.getFileSizeAsync(this.prefix_url + path, cb);
        };
        XmlHttpRequest.prototype._requestFileSizeSync = function (path) {
            return xhr.getFileSizeSync(this.prefix_url + path);
        };

        XmlHttpRequest.prototype._requestFileAsync = function (p, type, cb) {
            xhr.asyncDownloadFile(this.prefix_url + p, type, cb);
        };

        XmlHttpRequest.prototype._requestFileSync = function (p, type) {
            return xhr.syncDownloadFile(this.prefix_url + p, type);
        };

        XmlHttpRequest.prototype.getName = function () {
            return 'XmlHttpRequest';
        };

        XmlHttpRequest.isAvailable = function () {
            return typeof XMLHttpRequest !== "undefined" && XMLHttpRequest !== null;
        };

        XmlHttpRequest.prototype.diskSpace = function (path, cb) {
            cb(0, 0);
        };

        XmlHttpRequest.prototype.isReadOnly = function () {
            return true;
        };

        XmlHttpRequest.prototype.supportsLinks = function () {
            return false;
        };

        XmlHttpRequest.prototype.supportsProps = function () {
            return false;
        };

        XmlHttpRequest.prototype.supportsSynch = function () {
            return true;
        };

        XmlHttpRequest.prototype.preloadFile = function (path, buffer) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            }
            var stats = inode.getData();
            stats.size = buffer.length;
            stats.file_data = new preload_file.NoSyncFile(this, path, FileFlag.getFileFlag('r'), stats, buffer);
        };

        XmlHttpRequest.prototype.stat = function (path, isLstat, cb) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                return cb(new ApiError(1 /* ENOENT */, "" + path + " not found."));
            }
            var stats;
            if (inode.isFile()) {
                stats = inode.getData();

                if (stats.size < 0) {
                    this._requestFileSizeAsync(path, function (e, size) {
                        if (e) {
                            return cb(e);
                        }
                        stats.size = size;
                        cb(null, stats);
                    });
                } else {
                    cb(null, stats);
                }
            } else {
                stats = inode.getStats();
                cb(null, stats);
            }
        };

        XmlHttpRequest.prototype.statSync = function (path, isLstat) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            }
            var stats;
            if (inode.isFile()) {
                stats = inode.getData();

                if (stats.size < 0) {
                    stats.size = this._requestFileSizeSync(path);
                }
            } else {
                stats = inode.getStats();
            }
            return stats;
        };

        XmlHttpRequest.prototype.open = function (path, flags, mode, cb) {
            var _this = this;

            var inode = this._index.getInode(path);
            if (inode === null) {
                return cb(new ApiError(1 /* ENOENT */, "" + path + " is not in the FileIndex."));
            }
            if (inode.isDir()) {
                return cb(new ApiError(8 /* EISDIR */, "" + path + " is a directory."));
            }
            var stats = inode.getData();
            switch (flags.pathExistsAction()) {
                case 1 /* THROW_EXCEPTION */:
                case 2 /* TRUNCATE_FILE */:
                    return cb(new ApiError(6 /* EEXIST */, "" + path + " already exists."));
                case 0 /* NOP */:
                    if (stats.file_data != null) {
                        return cb(null, stats.file_data);
                    }

                    this._requestFileAsync(path, 'buffer', function (err, buffer) {
                        if (err) {
                            return cb(err);
                        }

                        stats.size = buffer.length;
                        stats.file_data = new preload_file.NoSyncFile(_this, path, flags, stats, buffer);
                        return cb(null, stats.file_data);
                    });
                    break;
                default:
                    return cb(new ApiError(9 /* EINVAL */, 'Invalid FileMode object.'));
            }
        };

        XmlHttpRequest.prototype.openSync = function (path, flags, mode) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " is not in the FileIndex.");
            }
            if (inode.isDir()) {
                throw new ApiError(8 /* EISDIR */, "" + path + " is a directory.");
            }
            var stats = inode.getData();
            switch (flags.pathExistsAction()) {
                case 1 /* THROW_EXCEPTION */:
                case 2 /* TRUNCATE_FILE */:
                    throw new ApiError(6 /* EEXIST */, "" + path + " already exists.");
                case 0 /* NOP */:
                    if (stats.file_data != null) {
                        return stats.file_data;
                    }

                    var buffer = this._requestFileSync(path, 'buffer');

                    stats.size = buffer.length;
                    stats.file_data = new preload_file.NoSyncFile(this, path, flags, stats, buffer);
                    return stats.file_data;
                default:
                    throw new ApiError(9 /* EINVAL */, 'Invalid FileMode object.');
            }
        };

        XmlHttpRequest.prototype.readdir = function (path, cb) {
            try  {
                cb(null, this.readdirSync(path));
            } catch (e) {
                cb(e);
            }
        };

        XmlHttpRequest.prototype.readdirSync = function (path) {
            var inode = this._index.getInode(path);
            if (inode === null) {
                throw new ApiError(1 /* ENOENT */, "" + path + " not found.");
            } else if (inode.isFile()) {
                throw new ApiError(7 /* ENOTDIR */, "" + path + " is a file, not a directory.");
            }
            return inode.getListing();
        };

        XmlHttpRequest.prototype.readFile = function (fname, encoding, flag, cb) {
            var oldCb = cb;

            this.open(fname, flag, 0x1a4, function (err, fd) {
                if (err) {
                    return cb(err);
                }
                cb = function (err, arg) {
                    fd.close(function (err2) {
                        if (err == null) {
                            err = err2;
                        }
                        return oldCb(err, arg);
                    });
                };
                var fdCast = fd;
                var fdBuff = fdCast._buffer;
                if (encoding === null) {
                    if (fdBuff.length > 0) {
                        return cb(err, fdBuff.sliceCopy());
                    } else {
                        return cb(err, new buffer.Buffer(0));
                    }
                }
                try  {
                    cb(null, fdBuff.toString(encoding));
                } catch (e) {
                    cb(e);
                }
            });
        };

        XmlHttpRequest.prototype.readFileSync = function (fname, encoding, flag) {
            var fd = this.openSync(fname, flag, 0x1a4);
            try  {
                var fdCast = fd;
                var fdBuff = fdCast._buffer;
                if (encoding === null) {
                    if (fdBuff.length > 0) {
                        return fdBuff.sliceCopy();
                    } else {
                        return new buffer.Buffer(0);
                    }
                }
                return fdBuff.toString(encoding);
            } finally {
                fd.closeSync();
            }
        };
        return XmlHttpRequest;
    })(file_system.BaseFileSystem);
    exports.XmlHttpRequest = XmlHttpRequest;

    browserfs.registerFileSystem('XmlHttpRequest', XmlHttpRequest);
});
//# sourceMappingURL=XmlHttpRequest.js.map
;